import React, { Component } from 'react';
import { PanelMarketing } from '../../components';
import './Home.css';

export default class MHome extends Component {
  render() {
    return (
      <div className="MHome">
        <PanelMarketing />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarketingHomeComponent/Home.js